import { render, staticRenderFns } from "./InfoContentComponent.vue?vue&type=template&id=4d31b7f1&scoped=true&"
import script from "./InfoContentComponent.vue?vue&type=script&lang=js&"
export * from "./InfoContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoContentComponent.vue?vue&type=style&index=0&id=4d31b7f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d31b7f1",
  null
  
)

export default component.exports